<template>
  <Card
    v-if="selected"
    class="chart-card"
  >
    <p slot="title">
      {{ title }}
    </p>
    <div
      v-if="showCharts"
      slot="extra"
      style="margin-top:-5px"
    >
      <Select
        v-model="type"
        size="small"
        style="width:100px"
      >
        <Option
          key="heatmap"
          label="Heatmap"
          value="heatmap"
        />
        <Option
          key="map"
          label="Map"
          value="map"
        />
      </Select>
      <template v-if="['bar', 'line'].includes(type)">
        <Select
          v-model="aggregation"
          size="small"
          class="select"
        >
          <Option
            v-if="columnType !== 'text' && xColumns.length"
            key="value"
            label="value"
            value="value"
          />
          <Option
            key="count"
            label="count"
            value="count"
          />
        </Select>
        <Select
          v-if="aggregation === 'value'"
          v-model="xColumn"
          size="small"
          transfer
          class="select"
        >
          <Option
            v-for="column in xColumns"
            :key="column"
            :label="column"
            :value="column"
          />
        </Select>
      </template>
    </div>
    <div
      v-if="showCharts"
      class="chart-container"
    >
      <HeatMap
        v-if="type === 'heatmap'"
        :data="data"
        :column="title"
      />
      <GoogleMap
        v-else-if="type === 'map'"
        :data="data"
        :column="title"
      />
    </div>
    <div
      v-if="!showCharts"
      class="chart-container"
    >
      <StatisticsTable
        :data="data"
        :column="title"
      />
    </div>
  </Card>
</template>

<script>
import _ from 'lodash'
import GoogleMap from './chart-components/GoogleMap'
import HeatMap from './chart-components/HeatMap'
import StatisticsTable from './chart-components/StatisticsTable'

export default {

  components: {
    GoogleMap,
    HeatMap,
    StatisticsTable
  },

  props: {
    data: Array,
    title: String,
    chartType: {
      type: String,
      required: true,
      default: 'bar',
      validator: value => ['bar', 'line', 'pie', 'map', 'heatmap'].includes(value)
    },
    selected: Boolean,
    showCharts: Boolean,
    typeObj: {
      type: Object,
      default: () => {},
      required: false
    }
  },

  data () {
    let xColumns = []
    let xColumn = ''
    let aggregation = 'value'
    let columnType = ''

    if (!_.isEmpty(this.typeObj)) {
      xColumns = Object.entries(this.typeObj).filter(([key, value]) => value !== 'text' && key !== this.title).map(([key]) => key)
      xColumn = xColumns[0]
      columnType = this.typeObj[this.title]
      if (columnType !== 'fixed') {
        aggregation = 'count'
      }
    }

    return {
      xColumn,
      xColumns,
      aggregation,
      columnType,
      type: this.chartType
    }
  }
}
</script>

<style scoped>
  .chart-card >>> .ivu-card-head {
    padding: 8px 16px;
  }

  .chart-card >>> .ivu-card-extra {
    margin-top: -2px;
  }

  /**
  * The default size is 600px×400px, for responsive charts
  * you may need to set percentage values as follows (also
  * don't forget to provide a size for the container).
  */
  .chart-container {
    width: 100%;
    height: 400px;
    display: inline-block;
    position: relative;
    border: 1px solid var(--color-box-shadow-border);
    border-radius: 8px;
    box-shadow: 0 0 45px var(--color-box-shadow);
    padding: 1.5em 2em;
  }

  .select {
    margin-left: 10px;
    width: 100px;
  }
</style>
